import React from 'react';
import { string, func, bool } from 'prop-types';
import * as styles from './styles/styles.module.scss';
import FavoriteButton from '../../../shared/FavoriteButton';
import ListImage from '../../ListImage';

const ListTableRow = ({ imgUrl, listTitle, handleFavoriteClick, isFavorite, listContents, isFavoriteRow }) => {
  const isEmptyListRow = listContents === '';
  return (
    <tr className={styles.container} data-testid="ListTableRow">
      <td className={styles.imageContainer}>
        <ListImage isFavoriteRow={isFavoriteRow} listTitle={listTitle} imgUrl={imgUrl} isEmptyListRow={isEmptyListRow} />
      </td>
      <td>
        <div className={styles.name}>{listTitle}</div>
        <div className={styles.contains}>{listContents}</div>
      </td>
      <td className={styles.favoriteButtonContainer}>
        <FavoriteButton onWhiteBg handleFavoriteClick={handleFavoriteClick} isFavorite={isFavorite} />
      </td>
    </tr>
  );
};

ListTableRow.propTypes = {
  imgUrl: string,
  listTitle: string,
  handleFavoriteClick: func.isRequired,
  isFavorite: bool,
  listContents: string,
  isFavoriteRow: bool
};

ListTableRow.defaultProps = {
  imgUrl: '',
  listTitle: '',
  isFavorite: false,
  listContents: '',
  isFavoriteRow: false
};

export default ListTableRow;
